import swagger from './swagger.json';
import {token, Token, UserContext} from '../auth/Auth';

const isDebug = process.env.NODE_ENV !== 'production';

class Endpoint {
    constructor(handlers, method, urlTemplate, parameters={}) {
        this.method = method;
        this.urlTemplate = urlTemplate;
        this.pathParameters = parameters.path;
        this.formParameters = parameters.form;
        this.bodyParameters = parameters.body;

        if (handlers) {
            this.onStartHandler = handlers.start || (() => handlers.setState({isLoading: true}));
            this.onEndHandler = handlers.end || (() => handlers.setState({isLoading: false}));
        }
    }

    async call(params = {}) {
        let {response, json} = await this.extendedCall(params);

        return json;
    }

    async extendedCall(params = {}) {
        let url = this.createUrl(params);

        if (this.onStartHandler)
            this.onStartHandler();

        let response = await fetch(url, {
            method: this.method,
            headers: new Headers({
                'Content-Type': this.bodyParameters
                    ? "application/json"
                    : "application/x-www-form-urlencoded",
                'Bearer': token.get()
            }),
            body: this.getBody(params),
            mode: isDebug ? 'cors' : undefined
        });

        if (response.status === 401 || response.status === 403) {
            UserContext.reset();
            Token.reset();

            window.location = '/login';
        }

        let json = await response.json();

        if (this.onEndHandler)
            this.onEndHandler();

        return {response, json};
    }

    sendFile(fileContent, params = {}) {
        return new Promise((resolve, reject) => {
            let url = this.createUrl(params);
            let xhr = new XMLHttpRequest();

            xhr.open(this.method, url);
            xhr.setRequestHeader('Content-Type', 'application/octet-stream');
            xhr.setRequestHeader('Bearer', token.get());
            xhr.addEventListener('load', function() {
                resolve(JSON.parse(this.responseText));
            });
            xhr.send(fileContent);
        });
    }

    createUrl(params = {}) {
        let url = this.urlTemplate;

        for (let paramName in params)
            if (params.hasOwnProperty(paramName)) {
                const urlParam = `{${paramName}}`;
                if (url.indexOf(urlParam) !== -1) {
                    url = url.replace(urlParam, params[paramName]);
                    delete params[paramName];
                }
            }

        if (!this.bodyParameters && !this.formParameters)
            url += '?' + Object.keys(params)
                .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
                .join('&');

        const baseUrl = isDebug
            ? 'http://localhost:5000'
            : `${window.location.origin}/api`;

        return baseUrl + url;
    }

    onStart(handler) {
        this.onStartHandler = handler;
    }

    onEnd(handler) {
        this.onEndHandler = handler;
    }

    getBody(params) {
        if (this.bodyParameters)
            return JSON.stringify(params[this.bodyParameters.name]);

        if (this.formParameters)
            return encodeURIComponent(this.formParameters.name)
                + '='
                + encodeURIComponent(params[this.formParameters.name]);

        return null;
    }
}


const BackEnd = {
};

const createEndpointHandler = function (endpoint, method, path, urlTemplate) {
    let controllerName = endpoint.tags[0].split(".")[0],
        actionName = endpoint.tags[0].split(".")[1],
        pathParameters = (endpoint.parameters || []).find(p => p.in === "path"),
        formParameters = (endpoint.parameters || []).find(p => p.in === "formData"),
        bodyParameters = (endpoint.parameters || []).find(p => p.in === "body");

    BackEnd[controllerName] = BackEnd[controllerName] || {};
    BackEnd[controllerName][actionName] = class extends Endpoint {
        constructor(handlers) {
            super(handlers, method, urlTemplate, {
                path: pathParameters,
                form: formParameters,
                body: bodyParameters
            });
        }
    };
};

const createPathEndpointHandlers = (path, urlTemplate) => {
    for (let method in path)
        if (path.hasOwnProperty(method))
            createEndpointHandler(path[method], method, path, urlTemplate);
};

for (let urlTemplate in swagger.paths)
    if (swagger.paths.hasOwnProperty(urlTemplate))
        createPathEndpointHandlers(swagger.paths[urlTemplate], urlTemplate);

export default BackEnd;


// WEBPACK FOOTER //
// ./src/backend/BackEnd.js